import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { NotebookPage } from "../types/note";
import { PageSubPagesMap } from "../types/sideNav";

export const getSubPages: (data: {
  "page-id": string;
  "app-id": string;
  limit?: number;
  skip?: number;
}) => Promise<NotebookPage[]> = async (data) => {
  const ednString = toEDNStringFromSimpleObject(data as any, {
    keysAs: "string",
  });
  const query = `
    (datastore Qo.Public.Api.SideNav "omega/query-omega/public/api/side-nav")
    (Qo.Public.Api.SideNav/sub-pages ${ednString} Response)
    (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const parentSubPagesSearch: (data: {
  "page-id": string;
  "app-id": string;
}) => Promise<PageSubPagesMap> = async (data) => {
  const ednString = toEDNStringFromSimpleObject(data as any, {
    keysAs: "string",
  });
  const query = `
    (datastore Qo.Public.Api.SideNav "omega/query-omega/public/api/side-nav")
    (Qo.Public.Api.SideNav/sub-pages-parent-search ${ednString} Response)
    (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
